import { useTranslation } from '../../../i18n/TranslationContext';

const statKeys = [
  { valueKey: 'stats.countries', labelKey: 'stats.countries_label' },
  { valueKey: 'stats.partners', labelKey: 'stats.partners_label' },
  { valueKey: 'stats.support', labelKey: 'stats.support_label' },
  { valueKey: 'stats.global_hub', labelKey: 'stats.global_hub_label' },
];

export default function StatsSection() {
  const { t } = useTranslation();

  return (
    <section className="py-12 md:py-16 bg-primary-50/40 border-b border-primary-100/40">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-0 divide-x divide-primary-100/40">
          {statKeys.map((stat, i) => (
            <div key={i} className="flex flex-col items-center justify-center py-6 md:py-10 px-4">
              <span className="text-3xl md:text-4xl lg:text-5xl font-heading text-primary-500 mb-1.5">
                {t(stat.valueKey)}
              </span>
              <span className="text-xs md:text-sm text-foreground-500 font-medium tracking-wide">
                {t(stat.labelKey)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}